module.exports = __webpack_public_path__ + "static/media/1POLICY41.a4628c52.jpg";